// skipcq: JS-W1028, JS-0128
import React from 'react';
import Grid from '@mui/material/Grid';
import BreweryDeets from './BreweryDeets';
import BreweryAmenities from './BreweryAmenities';
import BreweryLogo from './BreweryLogo';

/**
 * BreweryProfileGrid
 * Renders the brewery details, amenities, and logo in a grid layout.
 */
function BreweryProfileGrid({ brewery = {} }) {
  const {
    address1,
    city,
    name,
    logoUrl,
    state,
    zip,
    phone,
    website,
    facebook,
    twitter,
    isOob,
    oobDate,
    isTempClosed,
    email = '',
    socials,
    amenities = [],
  } = brewery;

  return (
    <Grid container spacing={2} sx={{
      p: 2
    }}>
      <Grid item xs={12} md={12}>
        <BreweryDeets
          name={name}
          address1={address1}
          city={city}
          state={state}
          zip={zip}
          phone={phone}
          website={website}
          facebook={facebook}
          twitter={twitter}
          isOob={isOob}
          isTempClosed={isTempClosed}
          oobDate={oobDate}
          email={email}
          socials={socials}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <BreweryAmenities amenities={amenities} />
      </Grid>
      <Grid item xs={12} md={12}>
        <BreweryLogo logoUrl={logoUrl} />
      </Grid>
    </Grid>
  );
}

export default BreweryProfileGrid;


